import { useEffect } from 'react'
import ReactTooltip from 'react-tooltip'

/**
 * react-tooltip v4 binds `data-tip` targets when the tooltip mounts. Any list
 * that shares one tooltip instance across items mounted later (pagination,
 * "show more", a newly added row) must rebuild once `dep` changes so the new
 * targets get bound too.
 */
const useRebuildTooltips = (dep) => {
    useEffect(() => {
        ReactTooltip.rebuild()
    }, [dep])
}

export default useRebuildTooltips
